export const PREVIOUS_REPLIES_CLIPPED = 'PREVIOUS_REPLIES_CLIPPED';
export const MOST_RECENT_REPLY_CLIPPED = 'MOST_RECENT_REPLY_CLIPPED';
export const NOT_CLIPPED = 'NOT_CLIPPED';